module.exports = __webpack_public_path__ + "static/media/nitcalicut.d620d6db.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/ContactUs/static/images/brands/nitcalicut.png
// module id = 70
// module chunks = 1